import type { WallTheme } from '@walls/store';

export const wallThemeDefaults = {
  panelColor: '#ffffff',
  panelTitleColor: '#022b3a',
  titleBackgroundColor: '#ffffff',
  titleColor: '#022b3a',
  yellowThemeColor: '#ffd04b',
  yellowThemeText: '#022b3a',
  blueThemeColor: '#04ceff',
  blueThemeText: '#ffffff',
};

export function getPanelColor(theme: WallTheme) {
  return theme.panelColor || wallThemeDefaults.panelColor;
}

export function getPanelTitleColor(theme: WallTheme) {
  return theme.panelTitleColor || wallThemeDefaults.panelTitleColor;
}

export function getTitleBackgroundColor(theme: WallTheme) {
  return theme.titleBackgroundColor || wallThemeDefaults.titleBackgroundColor;
}

export function getTitleColor(theme: WallTheme) {
  return theme.titleColor || wallThemeDefaults.titleColor;
}

export function getYellowActionColor(theme: WallTheme) {
  return theme.yellowThemeColor || wallThemeDefaults.yellowThemeColor;
}

export function getYellowActionTextColor(theme: WallTheme) {
  return theme.yellowThemeText || wallThemeDefaults.yellowThemeText;
}

export function getBlueActionColor(theme: WallTheme) {
  return theme.blueThemeColor || wallThemeDefaults.blueThemeColor;
}

export function getBlueActionTextColor(theme: WallTheme) {
  return theme.blueThemeText || wallThemeDefaults.blueThemeText;
}

export function getCustomHeaderTitle(theme: WallTheme) {
  const title = theme.title?.trim();
  return title && title.toLowerCase() !== 'dotstorming' ? title : null;
}
